
<template>
  <content-loader
    width="500"
    height="340"
    speed="2"
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <circle cx="9" cy="19" r="7" />
    <rect x="21" y="15" rx="5" ry="5" width="180" height="9" />
    <circle cx="9" cy="44" r="7" />
    <rect x="21" y="40" rx="5" ry="5" width="180" height="9" />
    <circle cx="9" cy="70" r="7" />
    <rect x="21" y="66" rx="5" ry="5" width="180" height="9" />
    <circle cx="9" cy="96" r="7" />
    <rect x="21" y="91" rx="5" ry="5" width="180" height="9" />
    <circle cx="10" cy="120" r="7" />
    <rect x="22" y="116" rx="5" ry="5" width="180" height="9" />
    <circle cx="10" cy="146" r="7" />
    <rect x="22" y="142" rx="5" ry="5" width="180" height="9" />
    <circle cx="10" cy="171" r="7" />
    <rect x="22" y="167" rx="5" ry="5" width="180" height="9" />
    <circle cx="10" cy="197" r="7" />
    <rect x="22" y="193" rx="5" ry="5" width="180" height="9" />
    <circle cx="10" cy="221" r="7" />
    <rect x="22" y="217" rx="5" ry="5" width="180" height="9" />
    <circle cx="10" cy="247" r="7" />
    <rect x="22" y="242" rx="5" ry="5" width="180" height="9" />
    <circle cx="10" cy="272" r="7" />
    <rect x="22" y="268" rx="5" ry="5" width="180" height="9" />
    <circle cx="10" cy="298" r="7" />
    <rect x="22" y="293" rx="5" ry="5" width="180" height="9" />
    <circle cx="11" cy="322" r="7" />
    <rect x="23" y="318" rx="5" ry="5" width="180" height="9" />
    <rect x="266" y="15" rx="0" ry="0" width="9" height="310" />
    <rect x="277" y="111" rx="0" ry="0" width="9" height="214" />
    <rect x="299" y="15" rx="0" ry="0" width="9" height="310" />
    <rect x="310" y="111" rx="0" ry="0" width="9" height="214" />
    <rect x="334" y="13" rx="0" ry="0" width="9" height="310" />
    <rect x="345" y="109" rx="0" ry="0" width="9" height="214" />
    <rect x="366" y="14" rx="0" ry="0" width="9" height="310" />
    <rect x="377" y="110" rx="0" ry="0" width="9" height="214" />
    <rect x="400" y="15" rx="0" ry="0" width="9" height="310" />
    <rect x="411" y="111" rx="0" ry="0" width="9" height="214" />
    <rect x="432" y="14" rx="0" ry="0" width="9" height="310" />
    <rect x="443" y="110" rx="0" ry="0" width="9" height="214" />
    <rect x="232" y="14" rx="0" ry="0" width="9" height="310" />
    <rect x="243" y="110" rx="0" ry="0" width="9" height="214" />
    <rect x="468" y="12" rx="0" ry="0" width="9" height="310" />
    <rect x="479" y="108" rx="0" ry="0" width="9" height="214" />
  </content-loader>
</template>
<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'AdvertisersChartLoader',
  components: { ContentLoader },
};
</script>



// WEBPACK FOOTER //
// AdvertisersChartLoader.vue?e62035c8